import './components/share'

import './scss/st8/styles.scss'
